export default __webpack_public_path__ + "static/young-04a27fa631e030e722c9bc5ece159ede.png";